import { render, staticRenderFns } from "./CrewsList.vue?vue&type=template&id=5fcdd4c8"
import script from "./CrewsList.vue?vue&type=script&lang=js"
export * from "./CrewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports